import React, { useState, useEffect } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { styled } from '@uhg-abyss/web/tools/styled';
import { FLOW_ID } from '@src/common/AppConstants';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { PageLayout } from '@src/common/PageLayout';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { useUser } from '@src/state/user';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { TINForm } from './TINForm';
import { getOrgType } from '@src/common/helpers';

const HeaderName = styled('h1', {
  margin: 'auto',
  fontSize: '36px',
  fontWeight: 600,
  paddingTop: '50px',
  textAlign: 'center',
  fontFamily: '$heading',
  color: '$primary1',
});

const ButtonView = styled('div', {
  width: '55%',
  display: 'flex',
  margin: 'auto',
  marginTop: '15px',
});

export const TaxInformation = () => {
  const lagoonContext = React.useContext(LagoonContext);

  const featureToggles = lagoonContext.getTable('feature-toggles');
  const { sourceTile } = useParams();
  const [errorRes, setErrorRes] = useState({});
  const { userUUID } = useUser.state();

  const getHeaderText = () => {
    if (
      sourceTile === FLOW_ID.PROVIDER ||
      sourceTile === FLOW_ID.API_MARKETPLACE_PROVIDER ||
      sourceTile === FLOW_ID.API_MARKETPLACE_PROVIDER_TECHNICIAN
    ) {
      return 'Register as Healthcare Professional or Facility';
    }
    if (
      sourceTile === FLOW_ID.BILLING ||
      sourceTile === FLOW_ID.API_MARKETPLACE_BILLING ||
      sourceTile === FLOW_ID.API_MARKETPLACE_BILLING_TECHNICIAN
    ) {
      return 'Register as a Revenue Cycle Management or Billing Company';
    }
    if (
      sourceTile === FLOW_ID.VENDOR ||
      sourceTile === FLOW_ID.API_MARKETPLACE_VENDOR ||
      sourceTile === FLOW_ID.API_MARKETPLACE_VENDOR_TECHNICIAN
    ) {
      return 'Register as a Business Vendor';
    }
    return '';
  };

  useEffect(() => {
    if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
      const orgType = getOrgType(sourceTile);
      const section1 = 'tin registration';
      const section3 = 'enter taxid';
      const pageName = `digitalsecurity:${section1}:${orgType}:${section3}`;
      adobeTaggingEvent('ON_PAGE_LOAD', {
        pageName,
        orgType,
        organization: '',
        uuid: userUUID,
        tin: '',
        section1,
        section2: orgType,
        section3,
      });
      adobeTaggingEvent('TIN_REGISTRATION_START', {
        jobName: `tin registration-${orgType}`,
        orgType,
      });
    }
  }, [sourceTile]);

  return (
    <PageLayout>
      <Grid.Col>
        <HeaderName>{getHeaderText()}</HeaderName>
      </Grid.Col>
      <Grid.Col>
        <TINForm setErrorRes={setErrorRes} errorRes={errorRes} />
      </Grid.Col>
      <Grid.Col>
        <ButtonView />
      </Grid.Col>
    </PageLayout>
  );
};
